import router from './router'

const whiteList = ['/login', '/userLogin', '/forgotPassword', '/register', '/enterprise', '/personal', '/user', '/logOff']
router.beforeEach((to, from, next) => {
    const defaultLoginPath = process.env.VUE_APP_ADDRESS === 'user' ? '/userLogin' : '/login'

    // next()
    if (localStorage.getItem('Token')) {
        if (to.path === '/login' || to.path === '/userLogin') {
            next({path: '/'})
        } else {
            next()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            console.log("===============" + `${defaultLoginPath}?redirect=${to.fullPath}`)
            next(`${defaultLoginPath}?redirect=${to.fullPath}`)
            //next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        }
    }
})

router.afterEach(() => {
    // NProgress.done()
})
